export default function TrustStrip() {
  const industries = [
    { icon: 'ri-bank-line', name: 'Finance & Accounting' },
    { icon: 'ri-heart-pulse-line', name: 'Healthcare & Medical' },
    { icon: 'ri-scales-3-line', name: 'Legal Services' },
    { icon: 'ri-building-line', name: 'Real Estate' },
    { icon: 'ri-briefcase-line', name: 'Small Business & Government' },
  ];

  return (
    <section className="py-8 bg-card border-y border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <p className="text-sm font-semibold text-foreground mb-1">
          Trusted by operations teams in regulated, high-stakes industries
        </p>
        <p className="text-xs text-muted-foreground mb-5">
          Built for precision, compliance, and scale.
        </p>
        <div className="flex flex-wrap justify-center gap-6 lg:gap-12">
          {industries.map((industry, index) => (
            <div key={index} className="flex items-center gap-2.5 text-muted-foreground">
              <i className={`${industry.icon} text-lg`}></i>
              <span className="text-sm font-medium">{industry.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}